import { useContent } from '~~/shared-components/content'

export const FIXED_NAVBAR = 'fixed-nav-bar'

const getNavbarHeight = () => {
  const fixedNavBar = document.getElementById(FIXED_NAVBAR)
  return fixedNavBar?.getBoundingClientRect()?.height ?? 0
}

const getOffsetTopRelativeToContainer = (
  el: HTMLElement | null,
  container: Element | undefined | null,
  useWindow: boolean
): number => {
  if (!el) return 0

  if (useWindow) {
    // Pro window scrollování - pozice elementu relativně k dokumentu
    if (!container) return 0
    const rect = el.getBoundingClientRect()

    return rect.top + window.scrollY
  } else {
    // Pro container scrollování použijeme původní logiku
    if (!container) return 0
    const elRect = el.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()
    return elRect.top - containerRect.top + (container as HTMLElement).scrollTop
  }
}

let abortController = new AbortController()
let correctionCount = 0
let lastScrollOffset = 0
let scrollDirection = 0 // 1 = dolů, -1 = nahoru

const onScrollListener = (
  element: HTMLElement,
  originalY: number,
  behavior: ScrollBehavior = 'smooth',
  isWindowScroll: boolean
) => {
  const currentScrollOffset = window.pageYOffset || document.documentElement.scrollTop

  // Detekce směru scrollování
  if (currentScrollOffset > lastScrollOffset) {
    scrollDirection = 1 // dolů
  } else if (currentScrollOffset < lastScrollOffset) {
    scrollDirection = -1 // nahoru
  }
  lastScrollOffset = currentScrollOffset

  // Přepočítej aktuální cílovou pozici
  const currentTargetY = getY(element, isWindowScroll)

  // Kontrola, zda se cílová pozice změnila (navbar se změnil)
  if (Math.abs(currentTargetY - originalY) > 5) {
    abortController.abort()
    correctionCount++

    // if (correctionCount > 3) {
    //   console.warn('Too many corrections, stopping')
    //   correctionCount = 0
    //   return
    // }

    abortController = new AbortController()

    window.addEventListener(
      'scroll',
      () => onScrollListener(element, currentTargetY, behavior, isWindowScroll),
      { signal: abortController.signal }
    )

    window.scrollTo({ top: currentTargetY, behavior })
    return
  }

  // Kontrola, zda jsme na cílové pozici NEBO jsme ji přestřelili
  const distanceToTarget = Math.abs(currentScrollOffset - currentTargetY)
  const atPosition = distanceToTarget < 2

  // Detekce přestřelení - scroll jde v opačném směru, než by měl
  const shouldScrollDown = currentScrollOffset < currentTargetY
  const shouldScrollUp = currentScrollOffset > currentTargetY
  const overshoot =
    (shouldScrollDown && scrollDirection === -1) || (shouldScrollUp && scrollDirection === 1)

  if (atPosition) {
    abortController.abort()
    correctionCount = 0
  } else if (overshoot && distanceToTarget > 10) {
    abortController.abort()

    // Okamžitě scroll na přesnou pozici bez animace
    window.scrollTo({ top: currentTargetY, behavior: 'instant' })
    correctionCount = 0
  }
}

const getY = (element: HTMLElement, isWindowScroll: boolean) => {
  const navbarHeight = getNavbarHeight()

  let aboverNavbarHeight = 0
  document.querySelectorAll('[above-nav-bar="true"]').forEach((e) => {
    aboverNavbarHeight += e.getBoundingClientRect()?.height ?? 0
  })
  const containerElement = document.getElementsByClassName('@container/main')?.[0]

  return (
    getOffsetTopRelativeToContainer(element, containerElement, isWindowScroll) -
    (aboverNavbarHeight + navbarHeight)
  )
}

export const scrollToElement = (hash: string | 'top', behavior: ScrollBehavior = 'smooth') => {
  const nuxtApp = useNuxtApp()

  nuxtApp.runWithContext(() => {
    // Ukonči předchozí listener a resetuj stav
    abortController.abort()
    abortController = new AbortController()
    correctionCount = 0
    lastScrollOffset =
      window.visualViewport?.pageTop || window.pageYOffset || document.documentElement.scrollTop
    scrollDirection = 0

    const { isEditContentActive } = useContent()
    const containerElement = document.getElementsByClassName('@container/main')?.[0]
    const isWindowScroll = !isEditContentActive.value
    let y = 0
    if (hash !== 'top') {
      const element = document.getElementById(hash)

      if (!element) {
        console.warn('Element not found:', hash)
        return
      }

      y = getY(element, isWindowScroll)
    }

    if (isWindowScroll) {
      if (hash !== 'top') {
        const element = document.getElementById(hash)!

        window.addEventListener(
          'scroll',
          () => onScrollListener(element, y, behavior, isWindowScroll),
          { signal: abortController.signal }
        )
      }

      window.scrollTo({ top: y, behavior })
    } else {
      containerElement?.scrollTo({ top: y, behavior })
    }
  })
}
